import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  RESOURCE_ADMIN_TABS,
  ResourceAccessService,
  ResourcePlanningAccess
} from '../Services/resource-access.service';

/** Boolesche Rechte aus /resourceplanning/access/me, die eine Route verlangen kann. */
export type ResourceAccessFlag =
  'canManagePlanning' | 'canViewCapacity' | 'canManageSkills' | 'canManageEmployees' | 'canManageTeams';

/**
 * Blendet Bereiche der Ressourcenplanung ohne passendes Recht aus. Route-Data:
 * - `access`: ein Recht oder eine Liste (eines davon genügt); Standard canManagePlanning.
 * - `firstAdminTab: true`: leitet auf den ersten erlaubten Reiter der Verwaltung weiter.
 * Nur Benutzerführung – die API prüft selbst.
 */
@Injectable({ providedIn: 'root' })
export class ResourceManageGuard implements CanActivate {
  constructor(private access: ResourceAccessService, private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const required = route.data?.['access'] ?? 'canManagePlanning';
    const flags: ResourceAccessFlag[] = Array.isArray(required) ? required : [required];
    const fallback = this.router.parseUrl('/ressourcenplanung/mein-kalender');
    return this.access.getMine().pipe(
      map((p: ResourcePlanningAccess) => {
        if (route.data?.['firstAdminTab']) {
          const tab = RESOURCE_ADMIN_TABS.find(t => p[t.flag]);
          return tab ? this.router.parseUrl(`/ressourcenplanung/verwaltung/${tab.path}`) : fallback;
        }
        return flags.some(flag => p[flag]) ? true : fallback;
      }),
      catchError(() => of(fallback))
    );
  }
}
